import { Heading, NavTabs } from '@dreryk/react-components';

import { paymentsAndInvoicesTranslationKeys } from '../../translations';

import { usePaymentsAndInvoicesTabs } from './PaymentsAndInvoicesPanel.hooks';
import { PaymentsAndInvoicesNavParams } from './PaymentsAndInvoicesPanel.types';

export const PaymentsAndInvoicesPanel = (): JSX.Element => {
   const paymentsAndInvoicesTabs = usePaymentsAndInvoicesTabs();

   return (
      <>
         <Heading
            content={paymentsAndInvoicesTranslationKeys.heading}
            testId={'paymentsAndInvoicesHeading'}
            type={'h1'}
            bold
         />
         <NavTabs<PaymentsAndInvoicesNavParams> testId={'paymentsAndInvoicesNavTabs'}>
            {paymentsAndInvoicesTabs.map((tab) => (
               <NavTabs.Tab key={tab.param} param={tab.param} testId={tab.param} label={tab.label}>
                  {tab.content}
               </NavTabs.Tab>
            ))}
         </NavTabs>
      </>
   );
};
